// @flow

import stores from 'stores';

export default (storeId: string, data: TStorePhotos) => {
  return stores.doddleStores.updateStorePhotos(storeId, data);
};
